export default [
  {
    path: '/messages',
    name: 'messages',
    component: () => import('@/views/pages/messages/Messages'),
  },
]
